import type { IconProps } from "@/types/IconProps";

export function Minus(props: IconProps) {
  const { size = 24, className, color = "currentColor", ...svgProps } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      viewBox="0 0 24 24"
      className={className}
      width={size}
      height={size}
      {...svgProps}
    >
      <path d="M4 9.734h16v4.532H4z" />
    </svg>
  );
}
